<template>
  <div>
    <div v-for="(item, index) in cards" :key="index" :data-key="item.chartkey" :data="item">
      <charts
        v-if="item"
        :options="item.chartData"
        :height="item.chartHeight"
        :chartkey="item.chartkey"
        :direction="direction"
        :title="title"
        @showHorCharts="showHorCharts"
      />
    </div>
  </div>
</template>

<script>
import charts from './charts.vue'

export default {
  components: {
    charts,
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    direction: {
      type: String,
      default: 'vertical',
    },
    title: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    showHorCharts(key) {
      this.$emit('showHorChartsItem', key)
    },
  },
}
</script>

<style></style>
